function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.90553 6.22463L9.90103 8.22013M7.90553 6.22463V12.8763V6.22463ZM7.90553 6.22463L5.91003 8.22013L7.90553 6.22463Z",
  stroke: "white",
  strokeWidth: 1.33033,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.27193 4.97212C2.64282 5.13043 2.09317 5.51301 1.72625 6.04799C1.35933 6.58297 1.20039 7.23353 1.27929 7.87743C1.3582 8.52133 1.66952 9.11426 2.15476 9.54481C2.64 9.97537 3.26576 10.2139 3.91448 10.2156H4.57964",
  stroke: "white",
  strokeWidth: 1.33033,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.453 3.65576C10.2257 2.75551 9.66454 1.97538 8.88333 1.47352C8.10212 0.971664 7.15932 0.785628 6.24603 0.953126C5.33275 1.12062 4.51732 1.62912 3.96505 2.37554C3.41278 3.12196 3.16499 4.05045 3.2719 4.97279C3.2719 4.97279 3.37367 5.55947 3.58187 5.89205",
  stroke: "white",
  strokeWidth: 1.33033,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2313 10.2156C11.7009 10.2153 12.1651 10.1155 12.5934 9.92286C13.0217 9.73019 13.4044 9.449 13.7162 9.0978C14.0279 8.74659 14.2618 8.33334 14.4024 7.88524C14.5429 7.43713 14.587 6.96434 14.5317 6.49798C14.4764 6.03161 14.3229 5.58226 14.0814 5.17948C13.8399 4.7767 13.5158 4.42964 13.1305 4.16114C12.7452 3.89264 12.3074 3.70878 11.8459 3.62167C11.3844 3.53457 10.9097 3.54618 10.453 3.65576L9.56836 3.89655",
  stroke: "white",
  strokeWidth: 1.33033,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgCloudIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIcon);
export default __webpack_public_path__ + "static/media/cloud_icon.0fb2c5c0.svg";
export { ForwardRef as ReactComponent };